import { render, staticRenderFns } from "./ResearchNameModal.vue?vue&type=template&id=0f2d2184&"
import script from "./ResearchNameModal.vue?vue&type=script&lang=js&"
export * from "./ResearchNameModal.vue?vue&type=script&lang=js&"
import style0 from "./ResearchNameModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports